import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import BkDashboard from '../pages/dashboard/BkDashboard';
import SuccessScreen from '../components/success-screen/SuccessScreen';
import UserFlow from '../pages/user-flow/UserFlow';
import BkFooter from '../components/footer/BkFooter';
import '../App.css';
import { ProtectedRoute } from './ProtectedRoute';
import TermsOfService from '../pages/settings/TermsOfUse';
import PrivacyPolicy from 'src/pages/settings/PrivacyPolicy';
import ProcessEmailReset from 'src/components/user-flow/ProcessEmailReset';
import { NoticeFormGuardWrapper } from 'src/pages/create-notice/NoticeFormGuardWrapper';
import { PaymentMethodsStatus } from 'src/utils/enums/payment-method-status.enum';
import { OrganizationType } from 'src/utils/enums/organization-type.enum';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      light: '#f7f2fa',
      dark: '#e8def8',
      main: '#436eb2',
    },
  },
  typography: {
    fontFamily: 'Instrument Sans', // Use Instrument Sans as the primary font
  },
});

const RootRedirect: React.FC = () => {
  const userTeamRole = useSelector((state: RootState) => state.user.currentUser.teamRole);
  const isCosMember = ['admin', 'support'].includes(userTeamRole);
  const target = isCosMember ? '/admin-history' : '/home';
  return <Navigate to={target} replace />;
};

const AppRouter: React.FC = () => {
  const bannerStatus = useSelector((state: RootState) => state.user.bannerStatus);
  const paymentMethodsStatus = useSelector(
    (state: RootState) => state.company.paymentMethodsStatus,
  );
  const organizationType = useSelector((state: RootState) => state.user.currentUser?.organization?.type);
  const isChapter13 = organizationType === OrganizationType.CHAPTER_13_TRUSTEE;

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <main className="app-container">
          <Routes>
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<RootRedirect />} />
              <Route path="/:route?" element={<BkDashboard />} />
              <Route path="/create-notice/:type">
                <Route index element={<Navigate to="add-case-information" replace />} />
                <Route
                  path=":step"
                  element={
                    bannerStatus !== 'payment_failed' && (isChapter13 || paymentMethodsStatus !== PaymentMethodsStatus.MISSING) ? (
                      <NoticeFormGuardWrapper />
                    ) : (
                      <RootRedirect />
                    )
                  }
                />
              </Route>
              <Route path="/success" element={<SuccessScreen />} />
              {/* <Route path='/settings' element={<Settings />} /> */}
            </Route>
            <Route path="/auth/:type" element={<UserFlow />} />
            <Route path="/reset-email" element={<ProcessEmailReset />} />
            <Route path="/terms" element={<TermsOfService />} />
            {/* <Route path="/privacy" element={<PrivacyPolicy />} /> */}
          </Routes>
          <BkFooter />
        </main>
      </ThemeProvider>
    </Router>
  );
};

export default AppRouter;
